import React from "react";

const AboutUs = () => {
  return (
    <section className="py-16 px-6 bg-white" id="sobre-nosotros">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">Sobre Nosotros</h2>
        <p className="text-gray-600 text-lg leading-relaxed">
          En <span className="font-semibold text-indigo-600">Zamintech</span>, somos una empresa apasionada por la
          tecnología. Nos dedicamos al desarrollo de soluciones digitales innovadoras y a la venta de equipos tecnológicos
          de alta calidad. 
          <br className="hidden md:block" />
          Nuestro equipo está formado por profesionales con amplia experiencia en desarrollo de software, apps móviles y
          consultoría tecnológica. Acompañamos a nuestros clientes desde la idea hasta la implementación, ofreciendo un
          servicio personalizado y eficiente.
        </p>
      </div>
    </section>
  );
};

export default AboutUs;
